import { acceptAgreement } from "@/Services/TherapyApi/LegalAgreements";

import useLegalAgreementStore from "@/Modules/LegalAgreement/Store";

async function acceptLegalAgreementsAH(uuid: string) {
  const legalAgreementStore = useLegalAgreementStore();
  const legalAgreement = await acceptAgreement(uuid);

  legalAgreementStore.legalAgreements = legalAgreementStore.legalAgreements.map((la) => {
    if (la.uuid === legalAgreement.uuid) return legalAgreement;

    return la;
  });
}

export default acceptLegalAgreementsAH;
